import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetFeaturedProductQuery } from "../../products/productSlice";
import FeaturedProduct from "./featured-product/FeaturedProduct";
import QuiekViewModal from "../../../pages/QueikViewModal/QuiekViewModal";
import { featuredDB } from "../../../rki-data/category";

import { RiShoppingBasketLine } from "react-icons/ri";

import axios from "axios";
import { base_url } from "../../../server";
import { useTranslation } from "react-i18next";

import catagoryShape from "../../../assets/img/category/catagory-card-shape.png";
// import product1 from "../../../assets/img/category/product1.png";
// import product2 from "../../../assets/img/category/product2.png";
// import product3 from "../../../assets/img/category/product3.png";
// import product4 from "../../../assets/img/category/product4.png";
// import product5 from "../../../assets/img/category/product5.png";
// import product6 from "../../../assets/img/category/product6.png";
// import product7 from "../../../assets/img/category/product7.png";
// import product8 from "../../../assets/img/category/product8.png";
// import product9 from "../../../assets/img/category/product9.png";
// import product10 from "../../../assets/img/category/product10.png";
// import product11 from "../../../assets/img/category/product11.png";
// import product12 from "../../../assets/img/category/product12.png";
import Rating from "../../../shared/rating/Rating";

// const woodenData = [
//   { id: "1", price: "400", title: "Desi Small Bitter Gourd chota karela", url: product1 },
//   { id: "2", price: "222", title: "Hybrid Black,Brown Cauliflower Seeds", url: product2 },
//   { id: "3", price: "400", title: "Aavalu Small | Mustard Seeds Small", url: product3 },
//   { id: "4", price: "299", title: "Bold Mustard (Rai) | Mustard Seeds", url: product4 },
//   { id: "5", price: "111", title: "Organic masala Chilli powder-homemade", url: product5 },
//   { id: "6", price: "540", title: "Turmeric Powder Masala, Chilli Powder", url: product6 },
//   { id: "7", price: "1299", title: "Brown Jeera Seeds, Powder Masala", url: product7 },
//   { id: "8", price: "298", title: "Buy Cashew Nuts Small Size", url: product8 },
//   { id: "9", price: "298", title: "Golden Small Raisins | Raisins", url: product9 },
//   { id: "10", price: "798", title: "FreshoCartz Mini Mamra Almonds", url: product10 },
//   { id: "11", price: "229", title: "Whole-Inknut-Haritaki-Myrobalans", url: product11 },
//   { id: "12", price: "400", title: "Aapkidukan Babul Tree Gum - Baul Gum", url: product12 },
// ];

function FeaturedProducts() {
  const [data, setData] = useState();
  const [error, seterror] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const baseUrl = base_url();
  const getdata = async (page) => {
    setisLoading(true);
    try {
      // const res = await axios.get(`https://onlineparttimejobs.in/api/product/page/${page}&${12}`, { withCredentials: true })
      const res = await axios.get(`${baseUrl}product/page/0&10000`, {
        withCredentials: true,
      });
      setData(res.data);
      setisLoading(false);
    } catch (error) {
      console.log("Server Error !");
      seterror(true);
      setisLoading(false);
    }
  };
  useEffect(() => {
    getdata(0);
  }, []);
  console.log("data -", data);
  const [modelDataId, setModelDataId] = useState(null);
  const setProduct_id = (id) => {
    setModelDataId(id);
  };

  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setModelDataId(id);
    setShow(true);
  };

  const sortedData = useMemo(() => {
    return data?.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });
  }, [data]);

  return (
    <>
      <section
        className="productsSection p-30"
        // style={{ backgroundImage: `url(${catagoryShape})` }}
      >
        <div className="container">
          <div className="row featuredRow">
            <div className="col-lg-12">
              <div className="fishermanHeader ">
                <div className="fisherman-content bgTitle">
                  <h3>{t("Trending Products")}</h3>
                </div>
                <div className="fisherman-btn d-none">
                  <Link to="/products" className="optional-btn">
                    View More
                  </Link>
                </div>
              </div>
            </div>
            <FeaturedProduct
              data={sortedData}
              getFeaturedPro={getdata}
              isLoading={isLoading}
              error={error}
              handleShow={handleShow}
              setProduct_id={setProduct_id}
            />

            {/* <div className="serviceItemInfo">
              <div className="row">
                {woodenData.map((item) => {
                  return (
                    <div
                      className="col-lg-3 col-md-4 col-sm-6 col-xs-12"
                      key={item.id}
                    >
                      <div className="serviceItem">
                        <div className="serviceItemImg">
                          <img
                            src={item.url}
                            className="img-fluid"
                            alt={item.title}
                            title={item.title}
                          />
                        </div>
                        <div className="serviceItemText">
                          <Rating />
                          <h5>
                            <Link to="/products">
                              {item.title}{" "}
                              <i className="ri-arrow-right-up-fill"></i>
                            </Link>
                          </h5>
                          <p>₹{item.price}.00</p>
                          <div className="buyNowInfo">
                            <Link className="btn buyNow cart" to="/">
                              <RiShoppingBasketLine /> Cart{" "}
                              <i className="ri-arrow-right-up-fill" />
                            </Link>
                            <Link className="btn buyNow" to="/">
                              Buy Now
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div> */}
          </div>
        </div>

        {/* {modelDataId && (
          <QuiekViewModal modelDataId={modelDataId} show={show} onHide={handleClose} size="xl"
            centered />
        )} */}
      </section>
    </>
  );
}

export default FeaturedProducts;
